/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to use it`)
};

const es_age_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo usarlo`)
};

const de_age_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So verwenden Sie es`)
};

const nl_age_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe te gebruiken`)
};

const fr_age_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment l'utiliser`)
};

const it_age_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come usarlo`)
};

const pt_br2_age_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como usar`)
};

const pt_age_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como utilizá-la`)
};

const ja_age_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使い方`)
};

const zh_age_howto_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用方法`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_howto_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_howto_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_howto_title", locale)
	if (locale === "en") return en_age_howto_title(inputs)
	if (locale === "es") return es_age_howto_title(inputs)
	if (locale === "de") return de_age_howto_title(inputs)
	if (locale === "nl") return nl_age_howto_title(inputs)
	if (locale === "fr") return fr_age_howto_title(inputs)
	if (locale === "it") return it_age_howto_title(inputs)
	if (locale === "pt-BR") return pt_br2_age_howto_title(inputs)
	if (locale === "pt") return pt_age_howto_title(inputs)
	if (locale === "ja") return ja_age_howto_title(inputs)
	return zh_age_howto_title(inputs)
};